import {
  autenticado,
  getDadosUsuario,
  getUserDataCookie,
} from '../../services/auth'

export default async function facebookUser() {
  let user = false
  function getTelefone() {
    /* todo remover traco, espaco */
    let telefone = user.telefone_ddd + user.telefone
    return telefone.replace(/\D/g, '')
  }
  function getSexo() {
    return user.sexo == 'masculino' ? 'm' : 'f'
  }
  if (autenticado) {
    user = getUserDataCookie()
  }
  return user
    ? {
        em: `${user.email}`,
        fn: `${user.user_name}`,
        ph: `${getTelefone()}`,
        ge: `${getSexo()}`,
      }
    : {}
}
/*
Parâmetros:
em: Email (minúsculas). Ex: 'joao@email.com',
fn: Primeiro nome (minúsculas, sem espaços, sem acentos). Ex: 'joaopedro'
ln: Último nome (minúsculas, sem espaços, sem acentos). Ex: 'silva'
ph: Telefone (com DDD, e apenas números). Ex: '11987239283'
ge: Sexo. 'm' para masculino, 'f' para feminino
db: Data de Nascimento. Formato: AAAAMMDD. Ex: '19901029'
ct: Cidade (minúsculas, sem espaços, sem acentos). Ex:'saopaulo'
st: Estado (só a sigla, minúsculas): 'sp'
zp: CEP (sem traço). Ex: '13494100'
*/
